import { render, staticRenderFns } from "./CreaNivelUno.vue?vue&type=template&id=ec730122"
import script from "./CreaNivelUno.vue?vue&type=script&lang=js"
export * from "./CreaNivelUno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports